//珀莱雅
import Overview from './overview.vue';

export const componentMap = {
    overview: Overview
};